module.exports = __webpack_public_path__ + "static/img/101861.b9a74060.png";